import styled from "styled-components";

export const ThumbnailContainer = styled.div`
  display: flex;
  width: 8rem;
  margin: 0.5rem;
  justify-items: center;
`;

export const ThumbnailLink = styled.button`
  width: 8rem;
  display: flex;
  flex-direction: column;
  align-self: flex-end;
  justify-content: flex-end;
  border-radius: 4px;
  z-index: 1;
  transition: box-shadow 200ms ease-out, background-color 200ms ease-out;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: ${props => props.theme.assetList.thumbnail.hover};
  }
  &:focus,
  &:active {
    outline: none;
    background-color: ${props => props.theme.assetList.thumbnail.hover};
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }
`;

export const Thumbnail = styled.img`
  border: 0;
  box-shadow: ${props => `0 0 0 1px ${props.theme.assetList.thumbnail.border}`};
  display: inline-block;
  line-height: 0;
  width: 100%;
  transition: box-shadow 200ms ease-out;
  border-radius: 0;
  background-color: grey;
`;

export const ThumbnailCaptionContainer = styled.div`
  display: flex;
  width: 8rem;
  padding: 0.25rem;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`;

export const ThumbnailCaption = styled.div`
  display: flex;
  width: 8rem;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ThumbnailCaptionTitle = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 0.25rem;
  text-align: left;
`;

export const ThumbnailSubtitle = styled(ThumbnailCaptionTitle)`
  font-size: 11px;
  width: 100%;
  color: ${props => props.theme.text.secondary};
`;

export const ThumbnailCaptionIcon = styled.div`
  margin-right: 0.25rem;
`;



// WEBPACK FOOTER //
// ./app/styled-components/Thumbnail.js